import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SmartMateHeaderComponent } from './smart-mate-header/smart-mate-header.component';
import { BarcodeDetailsComponent } from './barcode-details/barcode-details.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { PromptComponentComponent } from './prompt-component/prompt-component.component';

import {PwaServiceService} from './pwa-service.service';

const initializer = (PwaServiceService: PwaServiceService) => () => PwaServiceService.initPwaPrompt();
@NgModule({
  declarations: [
    AppComponent,
    SmartMateHeaderComponent,
    BarcodeDetailsComponent,
    PromptComponentComponent
  ],
  imports: [
    BrowserModule,
    MatBottomSheetModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    MatToolbarModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ServiceWorkerModule.register('/sw-master.js', { enabled: true })
  ],
  entryComponents: [
    PromptComponentComponent,
  ],
  providers: [
    {provide: APP_INITIALIZER, useFactory: initializer, deps: [PwaServiceService], multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
